import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Logo } from "./Logo";
import { ShieldCheck, Mail, Phone, LogOut } from "lucide-react";

export function PendingApproval() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center px-6 py-12" data-testid="pending-approval">
      <div className="mb-8"><Logo /></div>
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
        <div className="mx-auto mb-5 h-16 w-16 rounded-full bg-[#7FD498]/20 flex items-center justify-center">
          <ShieldCheck className="h-8 w-8 text-[#2f7a45]" />
        </div>
        <h1 className="text-2xl font-extrabold text-[#373E45] mb-2">Tu cuenta está siendo verificada</h1>
        <p className="text-[#64748B] leading-relaxed">
          Hola{user?.contact_name ? ` ${user.contact_name}` : ""}, hemos recibido el registro de{" "}
          <strong className="text-[#373E45]">{user?.clinic_name || "tu clínica"}</strong>. Estamos revisando tus
          datos y tu cuenta se activará en <strong className="text-[#373E45]">menos de 24 horas</strong>. Cuando
          esté lista podrás acceder para consultar la disponibilidad y reservar ecografías.
        </p>

        <div className="mt-6 rounded-xl bg-[#F1F5F9] border border-slate-200 p-4 text-left">
          <p className="text-xs font-bold uppercase tracking-wide text-[#94A3B8] mb-2">¿Tienes alguna duda?</p>
          <a href="mailto:info@veteo.es" className="flex items-center gap-2 text-sm font-semibold text-[#373E45] hover:text-[#2f7a45]" data-testid="pending-email">
            <Mail className="h-4 w-4 text-[#7FD498]" />info@veteo.es
          </a>
          <a href="tel:+34613021483" className="flex items-center gap-2 text-sm font-semibold text-[#373E45] hover:text-[#2f7a45] mt-2" data-testid="pending-phone">
            <Phone className="h-4 w-4 text-[#7FD498]" />613 021 483
          </a>
        </div>

        <Button variant="outline" onClick={logout} className="mt-6 rounded-xl border-slate-300 text-[#373E45] font-bold" data-testid="pending-logout">
          <LogOut className="h-4 w-4 mr-1.5" />Cerrar sesión
        </Button>
      </div>
    </div>
  );
}
